// extracted by mini-css-extract-plugin
module.exports = {"main-container":"ProductDetail_main-container__3jrhE","left-container":"ProductDetail_left-container__39QDN","right-container":"ProductDetail_right-container__344MW"};